export default class ListInlineMachines {
  constructor($el) {
    this.$productSelect = $el.querySelector('select[data-list-inline-machines-product]');
    this.$packagingSelect = $el.querySelector('select[data-list-inline-machines-packaging]');
    this.$submit = $el.querySelector('button[data-list-inline-machines-submit]');

    const $list = $el.querySelector('.list__items');
    this.$empty = $list.querySelector('.list__item[data-list-inline-machines-empty]');
    this.itemObjs = this.getItemObjs($list);

    this.hiddenItemClass = 'list__item--hidden';

    this.bindEvents();
    this.updateList();
  }

  getItemObjs($list) {
    const $items = $list.querySelectorAll('.list__item[data-list-inline-machines-props]');

    return Array.from($items).map(($item) => {
      const props = JSON.parse($item.getAttribute('data-list-inline-machines-props'));

      return {
        $item,
        ...props,
      };
    });
  }

  bindEvents() {
    this.onFilterChangeEvent = this.onFilterChange.bind(this);
    this.$productSelect.addEventListener('change', this.onFilterChangeEvent);
    this.$packagingSelect.addEventListener('change', this.onFilterChangeEvent);

    this.$submit.addEventListener('click', this.onSubmitClick.bind(this));
  }

  onFilterChange() {
    this.updateList();
  }

  onSubmitClick(e) {
    e.preventDefault();
  }

  updateList() {
    let countVisible = 0;

    const filters = {
      product: this.$productSelect.value,
      packaging: this.$packagingSelect.value,
    };

    this.itemObjs.forEach((itemObj) => {
      const visible = ListInlineMachines.checkItemProps(itemObj, filters);
      ListInlineMachines.conditionalClassName(itemObj.$item, this.hiddenItemClass, !visible);
      if (visible) countVisible += 1;
    });

    ListInlineMachines.conditionalClassName(this.$empty, this.hiddenItemClass, countVisible > 0);
  }

  static checkItemProps(itemObj, { product, packaging }) {
    if (product === 'all') return true;
    if (product === '') return false;
    if (!itemObj.product.includes(product)) return false;
    if (packaging === '') return true;
    if (!itemObj.packaging.includes(packaging)) return false;

    return true;
  }

  static conditionalClassName($el, className, condition) {
    if (condition) {
      $el.classList.add(className);
    } else {
      $el.classList.remove(className);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.list[data-list-inline-machines]').forEach(
    $list => new ListInlineMachines($list),
  );
});
